import { render, staticRenderFns } from "./my_shop.vue?vue&type=template&id=b7acd4ce&scoped=true&"
import script from "./my_shop.vue?vue&type=script&lang=js&"
export * from "./my_shop.vue?vue&type=script&lang=js&"
import style0 from "./my_shop.vue?vue&type=style&index=0&id=b7acd4ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7acd4ce",
  null
  
)

export default component.exports